import React from "react"
import { styled } from "@mui/material/styles"
import CancelIconWithBorder from "components/atoms/_icons/CancelIconWithBorder"

type FormFieldProps = {
  id: string;
  label: string;
  value: string;
  icon?: React.ReactNode;
  isDeletable?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  onDeleteIconClick?: (e: React.MouseEvent) => void;
}

export default function FormField(props: FormFieldProps) {
  const {
    id,
    label,
    value,
    icon,
    isDeletable,
    onClick,
    onDeleteIconClick
  } = props

  return (
    <FormFieldContainer id={id}>
      <StyledLabel>
        {label}
      </StyledLabel>
      <div onClick={onClick}>
        <StyledValue style={{ paddingRight: isDeletable ? 45 : 16 }}>
          {value}
        </StyledValue>
        <IconWrapper>
          {icon}
        </IconWrapper>
      </div>
      {isDeletable && value && <TrashIconWrapper onClick={onDeleteIconClick}>
          <CancelIconWithBorder/>
      </TrashIconWrapper>}
    </FormFieldContainer>
  )
}

const FormFieldContainer = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "auto",
  backgroundColor: "#FFFFFF"
}))

export const StyledLabel = styled("p")(({ theme }) => ({
  fontSize: "1.2rem",
  color: theme.palette.gray["12"],
  position: "absolute",
  transform: "translate(18px, -22px) scale(1)",
  fontWeight: 300
}))

const StyledValue = styled("div")(({ theme }) => ({
  width: "100%",
  height: "48px",
  border: `1px solid ${theme.palette.gray["8"]}`,
  borderRadius: "25px",
  marginBottom: "4.4rem",
  padding: "14px 16px",
  fontSize: "1.2rem",
  color: theme.palette.gray["13"],
  fontFamily: "VazirmatnFD, serif !important"
}))

const IconWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "50%",
  right: 0,
  transform: "translate(-10px, -50%)",
  width: "40px",
  height: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "& svg": {
    stroke: theme.palette.gray["14"],
    width: 24,
    height: 24
  }
}))

const TrashIconWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: 0,
  transform: "translate(10px, -50%)",
  width: "40px",
  height: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "& svg": {
    stroke: theme.palette.error["4"],
    width: 24,
    height: 24
  }
}))

